import { Component, Inject } from '@angular/core';
import {
  MappedProduct,
  MappedTopping,
} from '../../../../../../../core/models/topping.model';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { ISummaryData } from '../../../../../../../core/models/summary-data';
import { FunnelService } from '../../../funnel.service';
import { ConfirmDialogComponent } from '../../../../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { SummaryService } from '../../../../../../../core/services/summary.service';
import { LoaderService } from '../../../../../../../core/services/loader.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-modal-extra-washing',
  standalone: false,
  templateUrl: './modal-extra-washing.component.html',
  styleUrl: './modal-extra-washing.component.scss',
})
export class ModalExtraWashingComponent {
  form: FormGroup;
  tunnelWashProducts: MappedProduct[] = [];
  specializedCenterWashProducts: MappedProduct[] = [];
  selectedProductId: string | null = null;
  selectedProductKey: string | null = null;
  selectedProduct: MappedProduct | null = null;
  summaryData = {} as ISummaryData;

  constructor(
    private dialogRef: MatDialogRef<ModalExtraWashingComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { orderHash: string; mappedTopping: MappedTopping },
    private funnelService: FunnelService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private summaryService: SummaryService,
    private loaderService: LoaderService
  ) {
    this.form = this.fb.group({});
  }

  ngOnInit(): void {
    console.log('data', this.data);
    const summary = this.summaryService.getSummary();
    if (summary) {
      this.summaryData = summary;
    } else {
      this.summaryData = {} as ISummaryData;
    }
    this.initializeWashingOptions();
  }

  initializeWashingOptions(): void {
    const tunnelWash = this.data.mappedTopping.products.find(
      (product: MappedProduct) => product.id === 'tunnel-wash'
    );
    const specializedWash = this.data.mappedTopping.products.find(
      (product: MappedProduct) => product.id === 'specialized-center-wash'
    );

    this.tunnelWashProducts =
      tunnelWash && tunnelWash.relatedProducts
        ? tunnelWash.relatedProducts
        : [];
    this.specializedCenterWashProducts =
      specializedWash && specializedWash.relatedProducts
        ? specializedWash.relatedProducts
        : [];

    // Ordenar specializedCenterWashProducts según el atributo `order`
    this.specializedCenterWashProducts.sort(
      (a, b) => (a.order ?? 0) - (b.order ?? 0)
    );

    this.tunnelWashProducts.forEach((product) => {
      if (!product.titleId) product.titleId = product.productKey;
    });
    this.specializedCenterWashProducts.forEach((product) => {
      if (!product.titleId) product.titleId = product.productKey;
    });

    console.log(this.specializedCenterWashProducts);
  }

  onClose(): void {
    const confirmationDialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'sure_you_wanna_leave',
        message: 'disclousure_message_confirmation_dialog',
        confirmText: 'confirm',
        cancelText: 'cancel',
      },
    });

    confirmationDialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.closeMainDialog();
      }
    });
  }

  private closeMainDialog(): void {
    this.dialogRef.close({ incompletedTopping: true });
  }

  handleProductSelection(data: MappedProduct): void {
    this.selectedProductKey = data.titleId;
    this.selectedProductId = data.id;
    this.selectedProduct = data;
  }

  addTopping(): void {
    this.loaderService.show();
    this.funnelService.addTopping(this.selectedProductId!, this.data.orderHash, {}, 'wash')?.pipe(
            finalize(() => this.loaderService.hide()),
          ).subscribe((response) => 
      {
        this.summaryData = {
          ...this.summaryData,
          bookingResponse: response
        }
        this.summaryService.setSummary(this.summaryData);
        this.dialogRef.close({ selectedProduct: this.selectedProduct, response: response });
      }
    );
  }
}
